// Share estimate URL encoding/decoding — client-side only, no server round-trip
// CRITICAL: encode/decode order is load-bearing for Unicode (£, em-dash, emoji):
//   encode: btoa(encodeURIComponent(...))
//   decode: decodeURIComponent(atob(...)) — order is REVERSED

interface EstimatePayload {
  q: string; // user question
  r: string; // AI response (truncated to 500 chars)
  t: number; // timestamp
}

export function messageHasCost(content: string): boolean {
  return content.includes('£');
}

export function encodeEstimate(userMessage: string, aiResponse: string): string {
  const payload: EstimatePayload = {
    q: userMessage,
    r: aiResponse.slice(0, 500),
    t: Date.now(),
  };

  try {
    const json = JSON.stringify(payload);
    const encoded = btoa(encodeURIComponent(json));
    return encoded;
  } catch {
    return '';
  }
}

export function decodeEstimate(encoded: string): EstimatePayload | null {
  if (!encoded || typeof encoded !== 'string') return null;

  // Reject oversized payloads (bound render cost / prevent abuse)
  if (encoded.length > 4000) return null;

  try {
    const json = decodeURIComponent(atob(encoded));
    const payload = JSON.parse(json);

    // Validate shape
    if (
      typeof payload.q !== 'string' ||
      typeof payload.r !== 'string' ||
      typeof payload.t !== 'number'
    ) {
      return null;
    }

    return payload;
  } catch {
    // Malformed base64, invalid JSON, or decoding failure — silently return null
    return null;
  }
}

export function buildShareUrl(encoded: string): string {
  const origin = typeof window !== 'undefined' ? window.location.origin : '';
  return `${origin}/?estimate=${encoded}`;
}
